export const pageLayoutDefaults = {
    skipLinkId: 'main-content',
    skipLinkText: 'Skip to the main content'
} as const;
